import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveCategory, setSidebarOpen } from '../../../../redux/user/sliceUserProjects';
import { IAppReduxStore } from '../../../../redux/store';
import Sidebar, { ISidebarAllDataBtnProps } from '../../../General/Sidebar/Sidebar';
import ProjectTree from './ProjectTree';

/**
 * Collapsable sidebar that shows the user the category structure of their projects.
 */
export default () => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'projectSelectionView' });

    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Get relevant values from Redux store. */
    const isOpen = useSelector((store: IAppReduxStore) => store.userProjects.settings.sidebarOpen);
    const activeCategory = useSelector(
        (store: IAppReduxStore) => store.userProjects.settings.activeCategory,
    );

    /** Tree structure to show in the sidebar. */
    const tree = <ProjectTree sortAz={true} />;

    /** 'State slice' for controlling the sidebar's open state. */
    const openState: [boolean, (open: boolean) => void] = [
        isOpen,
        open => {
            dispatch(setSidebarOpen(open));
        },
    ];

    /** Configuration for the sidebar's "all data" button. */
    const btnConfig: ISidebarAllDataBtnProps = {
        onClick: () => dispatch(setActiveCategory('')),
        active: activeCategory === '',
        title: t('allProjects'),
    };

    return <Sidebar {...{ tree, openState }} mainBtn={btnConfig} />;
};
